// Utility notifiche tab-level: NO Web Push / Service Workers.
// "Tab attivo" = tab visibile E finestra a fuoco (Page Visibility + hasFocus).

export const isTabActive = () =>
  document.visibilityState === "visible" && document.hasFocus();

export const notificationsSupported = () => "Notification" in window;

export const canNotify = () =>
  notificationsSupported() && Notification.permission === "granted";

let audioCtx = null;

// Ping discreto a due toni generato via Web Audio (nessun file esterno).
export const playPing = () => {
  try {
    if (!audioCtx) audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    if (audioCtx.state === "suspended") audioCtx.resume();
    const now = audioCtx.currentTime;
    // Doppio tono ascendente, più presente ma professionale (niente allarmi):
    // fondamentale + ottava leggera per dare corpo, decay morbido.
    [[880, 0, 0.18], [1318.51, 0.15, 0.24]].forEach(([freq, offset, vol]) => {
      const t = now + offset;
      [[1, vol], [2, vol * 0.25]].forEach(([mult, gainVal]) => {
        const osc = audioCtx.createOscillator();
        const gain = audioCtx.createGain();
        osc.type = "sine";
        osc.frequency.value = freq * mult;
        gain.gain.setValueAtTime(0.0001, t);
        gain.gain.linearRampToValueAtTime(gainVal, t + 0.015);
        gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.55);
        osc.connect(gain);
        gain.connect(audioCtx.destination);
        osc.start(t);
        osc.stop(t + 0.6);
      });
    });
  } catch {
    // silente: audio non disponibile
  }
};

export const showDesktopNotification = ({ title, body, tag, onClick }) => {
  if (!canNotify()) return null;
  try {
    const n = new Notification(title, { body, tag, icon: "/favicon.ico" });
    n.onclick = () => {
      window.focus();
      if (onClick) onClick();
      n.close();
    };
    return n;
  } catch {
    return null;
  }
};
